import { VideoPlayer } from '@morressier/ts';
import { useInitMux, useVideoPlayerWrapper, useVideoTracking } from 'components/VideoPlayer/hooks';
import { FC, useEffect, useRef } from 'react';
import { MuxDataOptions } from 'typings/videojs-mux';

const VideoPlayerCutter: FC<{
  onPlay?: (e?: Event) => void;
  logWatchTime?: (props: { watchedFor: number }) => void;
  videoSession: MorressierVideoSession | null;
  muxMetaData: Omit<
    MuxDataOptions,
    'video_duration' | 'player_init_time' | 'env_key' | 'video_encoding_variant'
  >;
  posterId: string;
  archiveStreamUrl?: string;
}> = props => {
  const { onPlay, posterId, videoSession, muxMetaData, archiveStreamUrl } = props;
  // In VideoPlayer component in @shared-ts we are  exposing its video reference as {video}.
  const videoPlayerCutterRef = useRef<{ video: HTMLVideoElement }>(null);
  useEffect(() => {
    const videoEl = videoPlayerCutterRef.current?.video;
    if (onPlay && videoEl) videoEl.addEventListener('play', onPlay);

    return () => {
      if (onPlay && videoEl) videoEl.removeEventListener('play', onPlay);
    };
  }, [onPlay]);

  useVideoTracking(videoPlayerCutterRef.current?.video, props.logWatchTime ?? (() => null));
  useInitMux(videoPlayerCutterRef.current?.video, muxMetaData);
  const {
    isPlaying,
    src,
    fileType,
    start,
    volume,
    playTime,
    onTimeUpdate,
    onSeek,
    setIsFullPage,
    isFullPage,
    onPlayChange,
    currentTime,
    setVolume,
    totalTime,
    isDebug,
    isEnded,
    handleRePlay,
  } = useVideoPlayerWrapper({
    id: posterId,
    videoSession,
    archiveStreamUrl,
  });
  return (
    <VideoPlayer
      ref={videoPlayerCutterRef}
      isDebug={isDebug}
      isPlaying={isPlaying}
      src={src}
      fileType={fileType}
      start={start}
      volume={volume}
      playTime={playTime}
      onTimeUpdate={onTimeUpdate}
      onSeek={onSeek}
      setIsFullPage={setIsFullPage}
      isFullPage={isFullPage}
      onPlayChange={onPlayChange}
      currentTime={currentTime}
      setVolume={setVolume}
      totalTime={totalTime}
      isEnded={isEnded}
      handleRePlay={handleRePlay}
    />
  );
};

export default VideoPlayerCutter;
